import { gsap } from "gsap";

const cursor = document.querySelector('.cursor');
const cursor_text = document.querySelector('.cursor span');

export function init() {
	document.addEventListener('mousemove', move, {once: true});
}

export function move(e) {
	var posX = e.clientX;
	var posY = e.clientY;
	var mouseX = 0;
	var mouseY = 0;

	gsap.to({}, 0.016, {
	  repeat: -1,
	  onRepeat: function() {
	    posX += (mouseX - posX) / 4;
	    posY += (mouseY - posY) / 4;
	    
	    gsap.set(cursor, {
	        css: {    
	        	opacity: 1,
	            left: posX,
	            top: posY
	        }
	    });
	  }
	});

	document.addEventListener('mousemove', (e) => {
	    mouseX = e.clientX;
	    mouseY = e.clientY;
	});

	document.addEventListener('click', (e) => {
		if (e.target.classList.contains('cursor-noclick') || e.target.closest('.cursor-noclick')) {
			return;
		}

		close();
	});

	listeners();
}

export function listeners() {
	const targets = document.querySelectorAll('a:not(.init), button:not(.init), input:not(.init), video:not(.init), .youtube');

	targets.forEach((el) => {

		if (el.classList.contains('init')) {
			return;
		}

	    el.addEventListener('mouseover', () => {
	    	open(el);
	    });

	    el.addEventListener('mouseout', () => {
	        close();
	    });

	    el.classList.add('init');
	})
}

export function open(el) {
	const data_classes = el.hasAttribute('data-cursor-classes') ? el.getAttribute('data-cursor-classes') : 'small';
	const classes = `active ${data_classes}`;
	const text = el.getAttribute('data-cursor-text');

    cursor_text.innerHTML = (text) ? text : "";

    classes.split(' ').forEach((classname) => {
        cursor.classList.add(classname);
    });
}

export function close() {
	cursor.classList.remove('opacity', 'small', 'medium', 'large', 'active', 'color');
}

export function text(s) {
	cursor_text.innerHTML = s;
}